<template>
  <div>
    <v-container
      v-if="!contentPage"
      class="fill-height"
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
        >
          Cargando...
          <v-icon>
            mdi-timer-sand-empty mdi-spin
          </v-icon>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="viewPage">
      <v-row>
        <v-col
          cols="12"
        >

          <v-tabs
            ref="tab"
            v-model="tabs"
            color="primary accent-4"
            right
            :grow="true"
            multiple
          >
            <v-tab>Usuario</v-tab>
          </v-tabs>

          <v-tabs-items
            v-model="tabs"
            class="mt-4"
          >
            <v-tab-item>

          <v-data-table
            :headers="headers"
            :items="students"
            :hide-default-footer="true"
          >

            <template v-slot:[`item.actions`]="{ item }">
              <details-students
                :id="item.actions.id"
                type-student="tutor"
              />
            </template>

          </v-data-table>

            </v-tab-item>
          </v-tabs-items>


        </v-col>
        <v-col
          cols="12"
          md="10"
        />
      </v-row>
      <help-button
        v-if="tabs < 2"
        :tutorial="tutorial"
      />
    </v-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import StudentsParent from '@/views/dashboard/pages/panel/StudentsParent'
  import HelpButton from '@/views/dashboard/pages/panel/HelpButton'
  import DetailsStudents from '@/views/dashboard/pages/panel/DetailsStudents'


  export default {
    components: {
      StudentsParent,
      HelpButton,
      DetailsStudents,
    },
    data () {
      return {
        viewPage: false,
        contentPage: false,
        invitationType: 'byStudent',
        dialogDetailsGroup: false,
        dataGroup: {},
        tabs: [0],
        fab: false,
        optionGroup: null,
        dialogOptionGroup: false,
        nameGroup: '',
        newName: '',
        studentSelect: '',
        headers: [
          { text: 'Nombre', value: 'name', aling: 'center' },
          { text: 'Acciones', value: 'actions', aling: 'center' },
        ],
      }
    },
    computed: {
      ...mapState(['userData', 'user']),
      students () {

          let students = this.userData.self

          console.log(this.userData.self)
          return students;
      },
      typeUser () {
        return this.userData.type
      },
      tutorial () {
        // if (this.tabs === 1) {
        //   return this.typeUser === 'parent' ? 'parent-players-all' : 'tutor-players-all'
        // } else if (this.tabs === 0) {
        //   return 'players-groups'
        // } else {
          return 'tutor-demo'
      },
    },
    watch: {
      dataGroup (val) {
        this.$store.commit('SET_DATA_GROUP', val)
      },
    },
    updated: function () {
      var ref = this
      this.$nextTick(function () {
        if (typeof ref.$refs.tab !== 'undefined') {
          this.contentPage = true
        }
      })
    },
    methods: {
      close () {
        this.$refs.form1.reset()
        this.dialogOptionGroup = false
        this.nameGroup = ''
        this.newName = ''
        this.studentSelect = ''
      },
    },
    beforeRouteEnter (to, from, next) {
      next(async vm => {
        const userData = await vm.$store.dispatch('GET_USER_DATA')
        if (userData.type === 'tutor' || userData.type === 'parent') {
          vm.viewPage = true
          next()
        } else {
          console.log('Está intentando ingresar a una pagina no autorizada.')
          next({
            name: 'Home',
          })
        }
      })
    },
  }
</script>
